/**
 * DEPRECATED use SDUIText
 */ export var TextJustification = /*#__PURE__*/ function(TextJustification) {
    TextJustification["TEXT_JUSTIFICATION_UNKNOWN"] = "TEXT_JUSTIFICATION_UNKNOWN";
    TextJustification["START"] = "START";
    TextJustification["CENTER"] = "CENTER";
    TextJustification["END"] = "END";
    return TextJustification;
}({});
